import { TextField } from '@material-ui/core';
import { observer } from 'mobx-react';
import * as React from 'react';
import { _IEditProps } from './_IEditProps';

const readonlyInputProps = { readOnly: true, disabled: false };
const readwriteInputProps = { readOnly: false, disabled: false };
const inputLabelProps = { shrink: true };

export const _SelectEdit = observer(function _SelectEdit(props: _IEditProps & {children: React.ReactNode}) {
	const {accessors, label, error, isRequired, isReadonly, className, helperText, classes, children} = props;
	const value = accessors.getter();
	return <TextField
		select
		className={className}
		disabled={isReadonly}
		error={error}
		helperText={helperText}
		InputLabelProps={inputLabelProps}
		inputProps={isReadonly ? readonlyInputProps : readwriteInputProps}
		label={label}
		onChange={accessors.handleChange}
		required={isRequired}
		value={value}
	>
		{children}
	</TextField>;
});
